"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var themes_1 = require("../themes");
exports.normalizeColor = function (color, theme) {
    if (!color) {
        return '';
    }
    var resolveColorPair = function (colorPair, theme) {
        var themeIsDark = !!(theme && theme.dark);
        if (themeIsDark && colorPair.dark) {
            return exports.normalizeColor(colorPair.dark, theme);
        }
        else if (!themeIsDark && colorPair.light) {
            return exports.normalizeColor(colorPair.light, theme);
        }
        return undefined;
    };
    if (typeof color !== 'object' && themes_1.ColorNameValues.includes(color) && theme) {
        var colorValue = theme.global.colors[color];
        if (colorValue) {
            // If the color has a light or dark object, use that
            if (typeof colorValue === 'object') {
                return resolveColorPair(colorValue, theme) || color;
            }
            // allow one level of indirection in color names
            return exports.normalizeColor(colorValue, theme);
        }
    }
    if (typeof color === 'object') {
        return resolveColorPair(color, theme) || 'inherit';
    }
    return color;
};
var parseHexToRGB = function (color) {
    return color.length === 4
        ? color.match(/[A-Za-z0-9]{1}/g).map(function (v) { return parseInt(v, 16); })
        : // https://stackoverflow.com/a/42429333
            color.match(/[A-Za-z0-9]{2}/g).map(function (v) { return parseInt(v, 16); });
};
var canExtractRGBArray = function (color) { return /^#/.test(color) || /^rgb/.test(color); };
var getRGBArray = function (color) {
    if (/^#/.test(color)) {
        return parseHexToRGB(color);
    }
    if (/^rgb/.test(color)) {
        return color.match(/rgba?\((\s?[0-9]*\s?),(\s?[0-9]*\s?),(\s?[0-9]*\s?).*?\)/).splice(1);
    }
    return color;
};
exports.colorIsDark = function (color) {
    var _a = getRGBArray(color), red = _a[0], green = _a[1], blue = _a[2];
    // http://www.had2know.com/technology/
    //  color-contrast-calculator-web-design.html
    var brightness = (299 * red + 587 * green + 114 * blue) / 1000;
    return brightness < 125;
};
exports.getRGBA = function (color, opacity) {
    if (color && canExtractRGBArray(color)) {
        var _a = getRGBArray(color), red = _a[0], green = _a[1], blue = _a[2];
        return "rgba(" + red + ", " + green + ", " + blue + ", " + (opacity || 1) + ")";
    }
    return undefined;
};
//# sourceMappingURL=colors.js.map